import React, { useState } from 'react';

const COLORS = ['bg-green-600', 'bg-teal-600', 'bg-blue-500', 'bg-indigo-500', 'bg-purple-500', 'bg-pink-500', 'bg-orange-500', 'bg-amber-600', 'bg-cyan-600', 'bg-lime-600'];

export const initialsOf = (name: string) => {
  const words = String(name || '?').replace(/\(.*?\)/g, '').trim().split(/\s+/).filter(Boolean);
  if (!words.length) return '?';
  return (words.length === 1 ? words[0].slice(0, 2) : `${words[0][0]}${words[words.length - 1][0]}`).toUpperCase();
};

const colorOf = (name: string) => COLORS[Array.from(name || '').reduce((s, c) => s + c.charCodeAt(0), 0) % COLORS.length];

interface Props { name: string; src?: string | null; size?: number; className?: string }

/** Ảnh đại diện; không có ảnh (hoặc ảnh lỗi) thì hiện chữ viết tắt trên nền màu cố định theo tên */
export function UserAvatar({ name, src, size = 40, className = '' }: Props) {
  const [broken, setBroken] = useState(false);
  const style = { width: size, height: size, fontSize: Math.max(10, Math.round(size * 0.36)) };
  if (src && !broken) {
    return <img src={src} alt={name} style={style} onError={() => setBroken(true)} className={`rounded-full object-cover flex-shrink-0 ${className}`} />;
  }
  return (
    <div style={style} className={`rounded-full text-white flex items-center justify-center font-bold flex-shrink-0 ${colorOf(name)} ${className}`}>
      {initialsOf(name)}
    </div>
  );
}
